/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {ILogService} from 'angular';
import {getCodesFS, TSBegruendungsCode} from '../../models/enums/TSBegruendungsCode';
import {TSSchadenfallEvent} from '../../models/enums/TSSchadenfallEvent';
import {TSSchadenfallStatus} from '../../models/enums/TSSchadenfallStatus';
import ErrorService from '../errors/service/ErrorService';

export default class BegruendungscodeMapperService {

    private schadenfallToBegruendungscode = new Map<TSSchadenfallStatus, Map<TSSchadenfallEvent, Array<TSBegruendungsCode>>>();

    private keineCodes: Array<TSBegruendungsCode> = [];

    private fsCodes: Array<TSBegruendungsCode> = getCodesFS();

    static $inject = ['ErrorService', '$log'];

    /* @ngInject */
    constructor(private errorService: ErrorService, private $log: ILogService) {
        this.initialize();
    }

    initialize() {

        let codesForInBearbeitungAS = new Map([
            [TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK, this.keineCodes],
            [TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, codesForInBearbeitungAS);

        let codesForInBearbeitungASStichentscheidFS = new Map([
            [TSSchadenfallEvent.STICHENTSCHEID_OK, this.fsCodes],
            [TSSchadenfallEvent.ABLEHNUNG, this.fsCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, codesForInBearbeitungASStichentscheidFS);

        let codesForAuftragSchaetzer = new Map([
            [TSSchadenfallEvent.SCHAETZUNG_DURCHGEFUEHRT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, codesForAuftragSchaetzer);

        let codesForUeberpruefungAS = new Map([
            [TSSchadenfallEvent.ZURUECK_AN_SCHAETZER, this.keineCodes],
            [TSSchadenfallEvent.ANLAUFSTELLE_SCHAETZUNG_OK, this.keineCodes],
            [TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, codesForUeberpruefungAS);

        let codesForUeberpruefungASStichentscheidFS = new Map([
            [TSSchadenfallEvent.STICHENTSCHEID_OK, this.fsCodes],
            [TSSchadenfallEvent.ABLEHNUNG, this.fsCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, codesForUeberpruefungASStichentscheidFS);

        let codesForUeberpruefungFS = new Map([
            [TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK, this.fsCodes],
            [TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK_PAPIER, this.fsCodes],
            [TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT, this.fsCodes],
            [TSSchadenfallEvent.ABLEHNUNG, this.fsCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, codesForUeberpruefungFS);

        let codesForWiederherstellung = new Map([
            [TSSchadenfallEvent.WIEDERHERSTELLUNG_AUSGEFUEHRT, []],
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, codesForWiederherstellung);

        let codesForUeberpruefungSchaeter = new Map([
            [TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT, this.keineCodes],
            [TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT_PAPIER, this.keineCodes],
            [TSSchadenfallEvent.WIEDERHERSTELLUNG_MANGELHAFT, this.keineCodes]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, codesForUeberpruefungSchaeter);

        let codesForAbrechnen = new Map([
            [TSSchadenfallEvent.ABRECHNUNG_OK, this.fsCodes],
            [TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT, this.fsCodes],
            [TSSchadenfallEvent.ABLEHNUNG, this.fsCodes],
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, codesForAbrechnen);

        let codesForNeuPapierFS = new Map([
            [TSSchadenfallEvent.FREIGABE_PAPIER_FS_6, []],
            [TSSchadenfallEvent.FREIGABE_PAPIER_FS_9, []]
        ]);
        this.schadenfallToBegruendungscode.set(TSSchadenfallStatus.NEU_PAPIER_FS, codesForNeuPapierFS);
    }

    public initBegruedungscodesForStatus(schadenfallStatus: TSSchadenfallStatus): Map<TSSchadenfallEvent, TSBegruendungsCode[]> {
        let possibleBegrundungscodes = this.schadenfallToBegruendungscode.get(schadenfallStatus);
        if (possibleBegrundungscodes === undefined) {
            this.$log.error('requested Begruendungscode list for status that has no such codes defined ' + schadenfallStatus);
            throw new Error('no Begruendungscode available for status ' + schadenfallStatus);
        }
        return possibleBegrundungscodes;

    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/BegruendungscodeMapperService.ts